/**
 * File: formatQuestion.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
class FormatQuestionController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, archiveService, $timeout,CONSTANTS, $sce, ARCHIVE_CONSTANTS) {
        this.writeNote = false;
        this.scope = $scope
        this.state = $state

        let academics = localStorageService.get('academicDetails')
        let userId = localStorageService.get('user_id')
        if (academics === undefined)
            $state.go('dashboard')
        let qpId = $state.params.qpId ? $state.params.qpId : academics.qp_id
        self = this;
        $scope.sectionName = ""
        $scope.sectionName = ""
        $scope.sectionInstruction = ""
        $scope.markForEach = 0
        $scope.attendQues = 0
        $scope.allQues = 0
        $scope.time = []
        $scope.sectionInstruction = ""
        $scope.show_edit_icon = true
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
         $scope.fileUrl=PREVIEW_URL
        $scope.formatQuestion = []
        $scope.is_qp_type_lW = false
        let normal_type = {
            _id : "normal",
            name : "Normal"
        }
        let new_activity_types = [{
            _id : "learning_outcome",
            name : "Learning Outcome"
        },{
            _id : "wrapup_test",
            name : "Wrap Up Test"
        }]
        $scope.new_type_KV = {}
        _.each(new_activity_types, function(one){
            $scope.new_type_KV[one._id] = one.name
        })
        const _LW_WT_INFO = {
            MAX_MARK : 10,
            MAX_QUES : 10,
            MIN_QUES : 10,
            ALLOWED_TYPES : _.pluck(ARCHIVE_CONSTANTS.ARCHIVE_QUESTION_TYPE_LIST_LW, "_id")
        }
        //$scope.tempData = $location.protocol() + "://" + $location.host() + ":4000"

        //   $scope.qpTitle = ""
        $scope.sectionQuestions = []
        $scope.sectionWiseQuestions = []

        $scope.hours = []
        for (var hour = 0; hour <= 12; hour++) {
            hour = hour > 9 ? hour : "0" + hour;
            $scope.hours.push(hour);
        }

        $scope.minutes = []
        for (var min = 0; min < 60; min++) {
            min = min > 9 ? min : "0" + min;
            $scope.minutes.push(min);
        }

        let MQ = MathQuill.getInterface(2);
        let redirectDetails = archiveService.getRedirectJson();
        archiveService.clearRedirectJson();

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $scope.loadData()

        }
        $scope.convertTitle = function (title, TYPE, insideAccordian) {
            if(TYPE == "LA" || TYPE == 'passage'){
                let plntxt = title ? String(title).replace(/<[^>]+>/gm, '') : ''; 
                let string =  plntxt.slice(0, 30);
                if(TYPE == 'passage'){
                    string =  "Passage Question";
                }
                return $sce.trustAsHtml(string);
            }
            var res = title
            if(!insideAccordian){
                res = res.slice(0, 30);
            }
            return $sce.trustAsHtml(res);
        }
        if (redirectDetails && redirectDetails.returnData) {
            if (redirectDetails.activeTab == "question") {
                let questions = [];
                _.each(redirectDetails.returnData, function(questionArchive) {
                    questions.push(questionArchive.resource._id)
                })
                academics['ques_ids'] = questions
                authService.callAPI(activityCons.API_SELECT_QUESTION, "POST", academics, (response) => {
                    if (response.result && response.result && response.result.data) {
                       $scope.loadData()
                    }
                })
            }
        }
        academics.qp_id = qpId
        let qpDet = {
            "qp_id": qpId,
            "teacher_id": userId,
            "school_id": academics.school_id
        }
        $scope.qp_doc = undefined
        $scope.questionType = activityCons.QUESTION_TYPE_DETAILS
        function showErrAlert(ev, text){
            $mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .title('Learning outcome / Wrap up test warning.')
                  .textContent(text)
                  .ariaLabel('Alert Dialog Demo')
                  .ok('Close')
                  .targetEvent(ev)
              );                
        }
        let isLWisLW = (qp_doc) => {
            let ret = false
            try{
                let typeids = _.pluck(new_activity_types, "_id")
                if(qp_doc){
                    if(qp_doc.qp_type && qp_doc.qp_type.activity_type && 
                        typeids.indexOf(qp_doc.qp_type.activity_type) !== -1){
                            ret = true
                        }
                }
                return ret
            }catch(e){
                console.log(e)
                ret = false
                return ret
            }
        }
        function set1Mark(){
            if($scope.is_qp_type_lW){
                $scope.markForEach = 1
            }
        }
        function setItemsLWWT(){
            try{
                if($scope.is_qp_type_lW){
                    $scope.hour = "01"
                    $scope.min = "00"
                    set1Mark()
                }
            }catch(e){
                console.log(e)
            }
        }
        let validateMinQuesAF = () => {
            try{
                let len = 0
                if($scope.is_qp_type_lW){
                    if($scope.formatQuestion.allQuestions && $scope.formatQuestion.allQuestions.length){
                        let ques_already = _.flatten(_.pluck($scope.formatQuestion.allQuestions, "questions"))
                        if(ques_already && ques_already.length){
                            len = len + Number(ques_already.length)
                        }
                    }
                    if(len < _LW_WT_INFO.MAX_QUES){
                        return false
                    }
                }
                return true
            }catch(e){
                console.log(e)
                return true
            }
        }
        let validateMinQues = () => {
            try{
                let len = 0
                if($scope.is_qp_type_lW){
                    if($scope.sectionWiseQuestions && $scope.sectionWiseQuestions.length){
                        let ques_already = _.flatten(_.pluck($scope.sectionWiseQuestions, "questions"))
                        if(ques_already && ques_already.length){
                            len = len + Number(ques_already.length)
                        }
                    }
                    if(len < _LW_WT_INFO.MIN_QUES){
                        return false
                    }
                }
                return true
            }catch(e){
                console.log(e)
                return true
            }
        }
        let validateMaxQues = () => {
            try{
                let len = $scope.sectionFormat.length
                if($scope.is_qp_type_lW){
                    if($scope.sectionWiseQuestions && $scope.sectionWiseQuestions.length){
                        let ques_already = _.flatten(_.pluck($scope.sectionWiseQuestions, "questions"))
                        if(ques_already && ques_already.length){
                            len = len + ques_already.length
                        }
                    }
                    if(len >= _LW_WT_INFO.MAX_QUES){
                        return false
                    }
                }
                return true
            }catch(e){
                console.log(e)
                return true
            }
        }
        let checkMaxMarks = (reference = {}, isPreviewBtn = false) => {
            let _total_marks = 0
            try{
                if($scope.is_qp_type_lW){
                    let markForEach = $scope.markForEach
                    let allQues = $scope.allQues
                    let attendQues = $scope.attendQues
                    let sectionFormat = $scope.sectionFormat
                    // console.log(markForEach, allQues, attendQues)
                    if(sectionFormat && sectionFormat.length){
                        let this_section_max = markForEach * attendQues
                        if(!isNaN(this_section_max)){
                            _total_marks = _total_marks + Number(this_section_max)
                        }
                        // for (let index = 0; index < sectionFormat.length; index++) {
                        //     try{
                        //         let this_section_max = markForEach * attendQues
                        //         let element = sectionFormat[index];
                        //         console.log(this_section_max)
                        //         if(!isNaN(element.qn_mark)){
                        //             _total_marks = _total_marks + Number(element.qn_mark)
                        //         }
                        //     }catch(e1){
                        //         console.log(e1)
                        //     }
                        // }
                    }
                    if($scope.sectionWiseQuestions && $scope.sectionWiseQuestions.length){
                        let sectionWiseQuestions = $scope.sectionWiseQuestions
                        for (let index = 0; index < sectionWiseQuestions.length; index++) {
                            let element = sectionWiseQuestions[index];
                            let mark_each_qn = element.mark_each_qn
                            let mandatory_no = element.mandatory_no
                            let this_section_max = Number(mark_each_qn) * Number(mandatory_no)
                            if(!isNaN(this_section_max)){
                                _total_marks = _total_marks + this_section_max
                            }
                        }
                        // let ques_already = _.flatten(_.pluck($scope.sectionWiseQuestions, "questions"))
                        // for (let index = 0; index < ques_already.length; index++) {
                        //     try{
                        //         let element = ques_already[index];
                        //         if(!isNaN(element.qn_mark)){
                                    
                        //         }
                        //     }catch(e2){
                        //         console.log(e2)
                        //     }
                        // }
                    }
                    console.log(_total_marks, '_total_marks')
                    if(!isPreviewBtn){
                        if(_total_marks > _LW_WT_INFO.MAX_MARK){
                            reference['_total_marks'] = _total_marks
                            return false
                        }
                    }else{
                        if(_total_marks !== _LW_WT_INFO.MAX_MARK){
                            reference['_total_marks'] = _total_marks
                            return false
                        }
                    }
                    
                    return true
                }else{
                    return true
                }
            }catch(e){
                console.log(e)
                return true
            }
            console.log(_total_marks)
        }
        $scope.auto_wrapup = false
        $scope.loadData=(call)=>{
            authService.callAPI(activityCons.API_GET_TRADITIONAL_ACTIVITY, "POST", qpDet, (response) => {
                if (response.result && response.result.status && response.result.data.data) {
                    let result = response.result.data.data[0]
                    $scope.qp_doc = result
                    $scope.is_qp_type_lW = isLWisLW($scope.qp_doc.basic_details[0])
                    $scope.auto_wrapup = result.basic_details[0].auto_wrapup
                    setItemsLWWT()
                    $scope.sectionFormat = []
                    $scope.qp_title = result.basic_details[0].question_paper_title
                    $scope.qnPaperId = result._id
                    $scope.practice_qn = result.basic_details[0].practice_qn
                    $scope.isPractice = $scope.practice_qn
                    $scope.activityId = result.basic_details[0].activity_id
                    if (result.temp_sections && result.temp_sections.length > 0)
                        $scope.formatQuestion.allQuestions = result.temp_sections
                    if (result.sections && result.sections.length > 0)
                        $scope.sectionWiseQuestions = result.sections
                    _.each($scope.formatQuestion.allQuestions, function(data, index) {
                        data.color = getColor(index);
                    })
                    if (result.basic_details[0].time) {
                        if(!$scope.is_qp_type_lW){
                            $scope.hour = result.basic_details[0].time.hour
                            $scope.min = result.basic_details[0].time.min
                        }
                    }
                    localStorageService.set('theme_id', result.theme_id)
                    $scope.$apply()
    
                    $scope.goToArchive = () => {
    
                        let searchFilters = [];
                        let authoring = academics
                        searchFilters.push({
                            type: 'curriculum',
                            value: {
                                _id: authoring.curriculum_id,
                                name: authoring.curriculum
                            },
                            deletable: false,
                            visible: false
                        });
                        searchFilters.push({
                            type: 'class',
                            value: {
                                _id: authoring.class_id,
                                name: authoring.class
                            },
                            deletable: false,
                            visible: false
                        });
                        searchFilters.push({
                            type: 'subject',
                            value: {
                                _id: authoring.subject_id,
                                name: authoring.subject
                            },
                            deletable: false,
                            visible: false
                        });
                        searchFilters.push({
                            type: "tab",
                            value: {
                                _id: "question",
                                name: "Questions"
                            },
                            deletable: false,
                            visible: false
                        });
                        let details = {
                            searchFilters: searchFilters,
                            previousState: {
                                state: 'formatQuestion',
                                params: $state.params
                            },
                            isMultiSelect: true,
                            isPractice: $scope.practice_qn,
                            activeTab: "question",
                            resourceType: {
                                _id: "question",
                                name: "Questions"
                            },
                            basic_details : $scope.qp_doc.basic_details[0]
                        }
                        archiveService.setRedirectJson(details)
                        localStorageService.set('academicDetails', academics)
                        $state.go("archives")
                    }
    
                }
            })
        }
       

        //})

        /*
         * Function to delete question from qp
         * 
         * @question : Object - Details of question
         * 
         * @return : Null
         *
         */
        $scope.deleteQuestion = (questionId, sectionId) => {

            var confirm = $mdDialog.confirm()
                .textContent('Do you want to delete this question?')
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {

                let obj = {
                    qp_id: qpId,
                    question_id: questionId,
                    section_id: sectionId
                }
                authService.callAPI(activityCons.API_DELETE_QUESTION, "POST", obj, function(response) {
                    if (response.result) {
                        //Number - Count of section without questions
                        let secEmptyCount = 0;

                        _.each($scope.formatQuestion.allQuestions, function(section, index) {

                            //Number - index of question which need to be removed
                            let quesIndex = section.questions.findIndex(i => i._id === questionId);
                            if (quesIndex !== -1) {
                                section.questions.splice(quesIndex, 1)
                            }
                            if (section.questions.length === 0) {
                                secEmptyCount++;
                            }
                        })
                        toastr.success("Question deleted successfully")
                            //  if no questions, redirect to create page by varun 8-8-2018
                        if (secEmptyCount === $scope.formatQuestion.allQuestions.length) {
                            $state.go("createActivity", {
                                qpId: qpId
                            })
                        }
                        $scope.$apply();
                    } else {
                        console.log("error : " + response.error)
                        console.log(response.error)
                    }
                })
            }, function() {});
        }
        function gotoEditPage(question){
            localStorageService.set("createQuesiton", {
                state: "tactivity",
                qp_id: qpId,
                question_id: question._id,
                qp_title: $scope.qp_title,
                activity_id: $scope.activityId,
                theme_id: localStorageService.get('theme_id'),
                class_id: academics.class_id,
                curriculum_id: academics.curriculum_id,
                subject_id: academics.subject_id,
                batch_id: academics.batch_id,
                session_id: academics.session_id,
                school_id: academics.school_id,
                practice_qn: $scope.practice_qn,
                academic_year: localStorageService.get("activeAcdYear"),
                isQuestionAvailable: true
            })
            $state.go("createQuestion")
        }
        function showCreateDuplicateConfirm(question, event){
            var confirm = $mdDialog.confirm({
                targetEvent: event,
                onComplete: function afterShowAnimation() {
                    var $dialog = angular.element(document.querySelector('md-dialog'));
                    var $actionsSection = $dialog.find('md-dialog-actions');
                    var $cancelButton = $actionsSection.children()[0];
                    var $confirmButton = $actionsSection.children()[1];
                    angular.element($confirmButton).addClass('md-raised');
                    angular.element($cancelButton).addClass('md-raised');
                }
            })
            .textContent('This is an approved question.Do you want to create a copy and continue?')
                .ok('Continue')
                .cancel('Cancel');
                
            $mdDialog.show(confirm).then(function() {
                let obj = {
                    qp_id: $state.params.qpId,
                    school_id: academics.school_id,
                    question_id: question._id,
                    question : question
                }
                authService.callAPI("/v0/activity/create/duplicate/question", "POST", obj, function(response) {
                    if(response.result && response.result.data && response.result.data.dupeQb){
                        let dupe_question = response.result.data.dupeQb
                        gotoEditPage(dupe_question)
                    }else{
                        gotoEditPage(question)
                    }
                })
            }, function() {
                toastr.info("You cancelled the process")
            });
        }
        function checkQuestionStatus(question, event){
            let obj = {
                qp_id: $state.params.qpId,
                school_id: academics.school_id,
                question_id: question._id
            }
            authService.callAPI("/v0/activity/questions/archivestatus", "POST", obj, function(response) {
                if (response.result) {
                    if(response.result.data){
                        gotoEditPage(question)
                    }else{
                        showCreateDuplicateConfirm(question, event)
                    }
                } else {
                    gotoEditPage(question)
                }
            })
        }
        /*
         * Function to edit question from qp
         * 
         * @question : Object - Details of question
         * 
         * @return : Null
         *
         */
        $scope.editQuestion = (question, event) => {
            checkQuestionStatus(question, event)
        }
            /*
             * Function to auto format qp
             * 
             * @return : Null
             *
             */
        $scope.autoformat = (ev) => {
            //String - Name of the theme
            if(!validateMinQuesAF()){
                let str = "Minimum " + _LW_WT_INFO.MAX_QUES + " questions required for Auto format."
                showErrAlert(ev, str)
                return false
            }
            let obj = {
                qp_id: $state.params.qpId,
                is_practice: $scope.practice_qn,
                user_id: userId,
                temp_sections: angular.copy($scope.formatQuestion.allQuestions),
                is_qp_type_lW : $scope.is_qp_type_lW
            }
            authService.callAPI(activityCons.API_AUTO_FORMAT, "POST", obj, function(response) {
                if (response.result) {
                    try{
                        autoApprove(function(res){
                            $state.go('qpSummary', {
                                qpId: qpId
                            })
                        })
                    }catch(e){
                        console.log(e)
                        gotQpPreview()
                    }
                } else {
                    console.log("error : " + response.error)
                    console.log(response.error)
                }
                
            })
        }

        $scope.onSetPolicy = () => {
            if ($scope.attendQues > $scope.allQues)
                $scope.attendQues = $scope.allQues
        }
        $scope.changeStatus = (status) => {
            if (status) {
                $scope.isIndividualMark = true
                $scope.allQues = $scope.sectionFormat.length
                $scope.attendQues = $scope.allQues
                    //Fixed bug #6220
                    //Developer- Raziya
                if ($scope.sectionFormat) {
                    _.each($scope.sectionFormat, function(eachQues) {
                        if (isNaN(eachQues.qn_mark))
                            eachQues.qn_mark = undefined
                    })
                }
            } else {
                $scope.isIndividualMark = false
            }
        }


        $scope.moveQuestion = function(ev, eachQues, index) {
            let questData = []
            let max_err = 0
            _.each($scope.formatQuestion.allQuestions, function(sections) {
                if (sections.name == eachQues.type) {
                    if (index > -1) {
                        if(validateMaxQues()){
                            sections.questions.splice(index, 1);
                            $scope.sectionFormat.push(eachQues)
                            $timeout(function() {
                                $scope.formatToLatex()
                            });
                        }else{
                            max_err++
                            return;
                        }
                    }
                }
            })
            if(max_err){
                // toastr.error("Only " + _LW_WT_INFO.MAX_QUES + " questions can be added.")
                let str = "Only " + _LW_WT_INFO.MAX_QUES + " questions can be added."
                showErrAlert(ev, str)
            }
            $scope.allQues = $scope.sectionFormat.length
            $scope.attendQues = $scope.allQues
            set1Mark()
        }


        $scope.moveFromSection = function(eachQues, index) {
            let questData = $scope.sectionFormat[index]
            let isTypeExists = false
            if (!$scope.formatQuestion.allQuestions)
                $scope.formatQuestion.allQuestions = [];
            if ($scope.formatQuestion.allQuestions.length > 0) {
                _.each($scope.formatQuestion.allQuestions, function(sections) {
                    if (sections.name == eachQues.type) {
                        sections.questions.push(questData)
                        isTypeExists = true
                    }
                })
            }
            if (!isTypeExists) {
                let secIndex = $scope.formatQuestion.allQuestions.length;
                let newSection = {
                    name: eachQues.type,
                    questions: [questData],
                    color: getColor(secIndex)
                }
                $scope.formatQuestion.allQuestions.push(newSection)
            }
            if (index > -1) {
                $scope.sectionFormat.splice(index, 1);
            }
            $timeout(function() {
                $scope.formatToLatex()
            });
            $scope.allQues = $scope.sectionFormat.length // to get total question in each section
            $scope.attendQues = $scope.allQues
            let total = 0;
            if ($scope.allQues === 0) {
                $scope.markForEach = 0
                $scope.sectionName = ""
                $scope.sectionInstruction = ""
            }
            let obj = {
                qp_id: $state.params.qpId,
                is_practice: $scope.practice_qn,
                user_id: userId,
                time: {
                    hour: $scope.hour,
                    min: $scope.min
                },
                total_mark: total,
                //total_questions: totalQuestions,
                title: $scope.qp_title,
                sections: angular.copy($scope.sectionWiseQuestions),
                temp_sections: angular.copy($scope.formatQuestion.allQuestions)
            }
            authService.callAPI(activityCons.API_SAVE_SECTION, "POST", obj, (response) => {
                if (response.result && response.result) {
                }
            })
            set1Mark()
        }

        $scope.moveFromCreatedSection = function(eachQues, index) {
                if ($scope.sectionFormat && $scope.sectionFormat.length > 0)
                    toastr.error("You have already selected one section")
                else {
                    $scope.sectionData = angular.copy($scope.sectionWiseQuestions)
                    $scope.sectionFormat = eachQues.questions
                    $scope.sectionName = eachQues.name;
                    $scope.sectionInstruction = eachQues.instruction;
                    $scope.attendQues = eachQues.mandatory_no;
                    $scope.allQues = eachQues.qn_no;
                    $scope.markForEach = eachQues.mark_each_qn;
                    if (eachQues.mark_each_qn > 0)
                        $scope.checkStatus = false
                    else
                        $scope.checkStatus = true
                    $scope.changeStatus($scope.checkStatus)
                    $scope.sectionWiseQuestions.splice(index, 1)
                    $timeout(function() {
                        $scope.formatToLatex()
                    });
                }

            }
            //To cancel editing section 
        $scope.closeSection = function() {
            if ($scope.sectionData.length > 0 && $scope.sectionFormat.length > 0)
                $scope.sectionWiseQuestions = $scope.sectionData
            $scope.errors = {}
            $scope.sectionName = ""
            $scope.sectionInstruction = ""
            $scope.markForEach = 0
            $scope.attendQues = 0
            $scope.allQues = 0
            $scope.checkStatus = false
            $scope.changeStatus($scope.checkStatus)
            $scope.sectionFormat = []
        }
        $scope.createSection = function(ev) {
            $scope.errors = {};
            let error = false
            if(!$scope.isPractice){
            if ($scope.hour === undefined || $scope.hour === ""||$scope.min === ""||$scope.min === undefined) {
                $scope.errors['hour'] = "time is required";
                error = true
                }
            }
            if ($scope.sectionName === undefined || $scope.sectionName === "") {
                $scope.errors['sectionName'] = "Section Name is required.";
                error = true
            }
            if ($scope.sectionInstruction === undefined || $scope.sectionInstruction === "") {
                $scope.errors['sectionInstruction'] = "Instruction is required.";
                error = true
            }
            if ($scope.sectionFormat.length === 0) {
                $scope.errors['selectQuestion'] = "Please add atleast one question.";
                error = true
            }
            if (!$scope.isIndividualMark) {
                if ($scope.markForEach === undefined || $scope.markForEach === "") {
                    $scope.errors['markForEach'] = "Enter mark for each question";
                    error = true

                }
                if ($scope.markForEach == 0) {
                    $scope.errors['markForEach'] = "Mark should be greater than 0";
                    error = true
                }
                //To save mark to each question
                if ($scope.markForEach > 0) {
                    _.each($scope.sectionFormat, function(eachQues) {
                        eachQues.qn_mark = $scope.markForEach
                    })
                }
            }

            if ($scope.isIndividualMark) {
                //Bug  #6132 -start
                $scope.markForEach = 0
                    //Bug  #6132 -end

                _.each($scope.sectionFormat, function(eachQues) {
                    if (eachQues.qn_mark) {
                        if (eachQues.qn_mark == 0) {
                            eachQues['qn_mark_error'] = true
                            toastr.error("Mark should be greater than 0")
                            error = true
                        } else
                            eachQues['qn_mark_error'] = false

                    }
                    if (!eachQues.qn_mark || eachQues.qn_mark === null || eachQues.qn_mark === undefined || eachQues.qn_mark === "") {
                        eachQues['qn_mark_error'] = true
                        toastr.error("Please enter mark for all questions")
                        error = true
                    } else
                        eachQues['qn_mark_error'] = false
                })
            }
            $scope.sectionFormat['is_individual_mark'] = $scope.checkStatus
            if ($scope.attendQues === undefined || $scope.attendQues === "") {
                $scope.errors['attendQues'] = "Enter policy";
                error = true
            }
            if ($scope.attendQues === 0) {
                $scope.errors['markForEach'] = "Please add atleast one question"
                error = true
            }
            _.each($scope.sectionWiseQuestions, function(section) {
                if (section.name === $scope.sectionName) {
                    $scope.errors['sectionName'] = "Section name already exsits";
                    error = true;
                }
            })
            console.log($scope.errors)
            console.log(error)
            if (!error) {
                let reference = {}
                if(checkMaxMarks(reference, false)){
                    $scope.sectionWiseQuestions.push({
                        'name': $scope.sectionName,
                        'instruction': $scope.sectionInstruction,
                        'mark_each_qn': $scope.markForEach,
                        'mandatory_no': $scope.attendQues,
                        'qn_no': $scope.allQues,
                        'questions': $scope.sectionFormat
                    })
                    let obj = {
                        qp_id: $state.params.qpId,
                        is_practice: $scope.practice_qn,
                        user_id: userId,
                        time: {
                            hour: $scope.hour,
                            min: $scope.min
                        },
                        title: $scope.qp_title,
                        sections: angular.copy($scope.sectionWiseQuestions),
                        temp_sections: angular.copy($scope.formatQuestion.allQuestions),
                        update_to_create_status : true
                    }
                    
                    
                    authService.callAPI(activityCons.API_SAVE_SECTION, "POST", obj, (response) => {
                        if (response.result && response.result) {
                        }
                    })
                    $scope.sectionFormat = []
                    $scope.sectionName = ""
                    $scope.sectionInstruction = ""
                    $scope.markForEach = 0
                    $scope.attendQues = 0
                    $scope.allQues = 0
                    $scope.checkStatus = false
                    $scope.changeStatus($scope.checkStatus)
                }else{
                    let str = "Activity total marks exceeded " + _LW_WT_INFO.MAX_MARK + " marks."
                    if(reference && reference._total_marks){
                        str = "Activity total marks exceeded " + _LW_WT_INFO.MAX_MARK + "." +
                        //  ".Now " +
                        // "it is "+ reference._total_marks +
                        // " marks." +
                         " Please reduce the number of questions or marks."
                    }
                    // toastr.error(str)
                    showErrAlert(ev, str)
                }
            }
        }

        var calIndex = function(index, length) {
            if (index >= length) {
                if ((index - length) >= length)
                    return calIndex(index - length, length)
                else
                    return index - length;
            } else
                return index;
        }

        var getColor = (index) => {
            var colorArr = ['#2ab4c0', '#1bbc9b', '#f3c200', '#e7505a'];
            var i = calIndex(index, colorArr.length);
            return colorArr[i];
        }
        _.each($scope.formatQuestion.allQuestions, function(data, index) {
                data.color = getColor(index);
            })
            // $scope.formatQuestion.addedQuestions = [];
        $scope.toggleExpansion = function(accordianData, data, index) {
            _.each(accordianData, function(data, dataIndex) {
                if (dataIndex != index)
                    data.expanded = false;
                else
                    data.expanded = !data.expanded;
            })
            $scope.formatToLatex()
        }

        $scope.formatToLatex = function() {
            $timeout(function() {
                var questionElements = document.getElementsByClassName('question_desc')
                _.each(questionElements, function(spanElement) {
                    MQ.StaticMath(spanElement);
                })
                var choiceElements = document.getElementsByClassName('choice-desc')
                _.each(choiceElements, function(spanElement) {
                    MQ.StaticMath(spanElement);
                })
            }, 1000)
        }


        $scope.preview = function(ev) {
            
            let obj = {
                qp_id: $state.params.qpId,
                user_id: userId,
                title: $scope.qp_title,
                is_practice: $scope.practice_qn,
                time: {
                    hour: $scope.hour,
                    min: $scope.min
                },
                sections: angular.copy($scope.sectionWiseQuestions) ? angular.copy($scope.sectionWiseQuestions) : [],
                temp_sections: $scope.formatQuestion.allQuestions ? angular.copy($scope.formatQuestion.allQuestions) : []
            }
            $scope.errors = {};
            let error = false
            // if ($scope.hour === undefined || $scope.hour === "" || $scope.hour === "00") {
            //     if ($scope.min === undefined || $scope.min === "" || $scope.min === "00") {
            //         $scope.errors['time'] = "time is required";
            //         error = true
            //     }
            // }
            if ($scope.hour === undefined || $scope.hour === "" || $scope.min === undefined || $scope.min === "") {
                if (!$scope.practice_qn) {
                    $scope.errors['time'] = "Time is required";
                    error = true
                }
            }
            if ($scope.sectionFormat && $scope.sectionFormat.length > 0) {
                toastr.warning("Please save the changes.")
                error = true
            }
            if (!error) {
                if(!validateMinQues()){
                    let str = "Number of questions should be  " + _LW_WT_INFO.MIN_QUES+"."
                    showErrAlert(ev, str)
                    return false
                }
                let reference = {}
                if(checkMaxMarks(reference, true)){
                    authService.callAPI(activityCons.API_SAVE_SECTION, "POST", obj, (response) => {
                        if (response.result && response.result) {
                            try{
                                autoApprove(function(res){
                                    if(res){
                                        $state.go('qpSummary', {
                                            qpId: qpId
                                        })
                                    }
                                })
                            }catch(e){
                                console.log(e)
                                gotQpPreview()
                            }
                        }
                    })
                }else{
                    let str = "" + _LW_WT_INFO.MAX_MARK + " marks"
                    if(reference && reference._total_marks){
                        str = "Activity total marks should be " + _LW_WT_INFO.MAX_MARK + ".Now " +
                        "it is "+ reference._total_marks +" marks."
                    }
                    // toastr.error(str)
                    showErrAlert(ev, str)
                }
            }
        }
        function autoApprove(callBack){
            if(!$scope.auto_wrapup){
                gotQpPreview()
            }else{
                authService.callAPI("/v0/auto/approve/wrapup/qp", "POST", qpDet, (response) => {
                    console.log(response.result)
                    if (response.result && response.result.data) {
                        try{
                            if(response.result.data.details){
                                callBack(true)
                            }else{
                                // toastr.warning("Cannot approve")
                                gotQpPreview()
                            }
                            
                        }catch(e){
                            console.log(e)
                            gotQpPreview()
                        }
                    }
                })
            }
        }
        function gotQpPreview(){
            $state.go('activityPreview', {
                qpId: $state.params.qpId
            })
        }
        $scope.routeToCreateQuestion = function() {
            if(academics){
                academics['is_qp_type_lW'] = $scope.is_qp_type_lW
            }
            localStorageService.set('academicDetails', academics)
            localStorageService.set("createQuesiton", {
                    state: "tactivity",
                    qp_id: qpId,
                    qp_title: $scope.qp_title,
                    activity_id: $scope.activityId,
                    theme_id: localStorageService.get('theme_id'),
                    class_id: academics.class_id,
                    curriculum_id: academics.curriculum_id,
                    subject_id: academics.subject_id,
                    batch_id: academics.batch_id,
                    session_id: academics.session_id,
                    school_id: academics.school_id,
                    practice_qn: $scope.practice_qn,
                    academic_year: localStorageService.get("activeAcdYear"),
                    isQuestionAvailable: true,
                    is_qp_type_lW : $scope.is_qp_type_lW 
                })
            $state.go("createQuestion", {
                isPractice: $scope.practice_qn
            }, {
                reload: true
            })

        }
        $scope.validateMark = function() {
            if ($scope.markForEach && $scope.markForEach > 100)
                $scope.markForEach = 0
        }
        $scope.addQnMark = function(eachQues) {
            if (eachQues.qn_mark > 0)
                eachQues['qn_mark_error'] = false
        }

        //Added for dragging sections
        //developer - Raziya
        $scope.sortableOptions = {
            containment: '#sortable-container'
        };
        $scope.dragControlListeners = {
            accept: function(sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            },
            itemMoved: function(event) {
                event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
            },
            orderChanged: function(event) {},
            dragStart: function() {},
            dragEnd: function() {},
            containment: '#board', //optional param.
            containerPositioning: 'relative',
            clone: false, //optional param for clone feature.
            allowDuplicates: false //optional param allows duplicates to be dropped.
        };
        $scope.sortableOptions1 = {
            containment: '#sortable-container',
            allowDuplicates: true,
            ctrlClone: true,
            orderChanged: function(event) {
            },
            dragStart: function(event, ui) {
                // let id = "sortFirst_" + event.source.index
                // document.getElementById(id).style.background = 'blue'
            },
            dragEnd: function() {
            },
            accept: function(sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            },
            itemMoved: function(event) {
                
                event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
            }
        }
        $scope.sortableOptions2 = {
            containment: '#sortable-container',
            allowDuplicates: true,
            ctrlClone: true,
            orderChanged: function(event) {
            },
            dragStart: function() {
            },
            dragEnd: function() {
            },
            accept: function(sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            },
            itemMoved: function(event) {
                event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
            }
        }
        function checkMinsDiff(min, basic_details){
            let time = basic_details.time ? basic_details.time : {}
            if(min != time.min){
                $scope.updateQpToCreatedStatus()
            }
        }
        function checkHourDiff(hour, basic_details){
            let time = basic_details.time ? basic_details.time : {}
            if(hour != time.hour){
                $scope.updateQpToCreatedStatus()
            }
        }
        $scope.onSelectChange = (field, value) => {
            if($scope.qp_doc){
                switch(field) {
                    case "min":
                        checkMinsDiff(value, $scope.qp_doc.basic_details[0])
                      break;
                    case "hour":
                        checkHourDiff(value, $scope.qp_doc.basic_details[0])
                      break;
                }
            }
        }
        $scope.updateQpToCreatedStatus = () => {
            if(qpId){
                let obj = {
                    qp_id : qpId
                }
                try{
                    authService.callAPI("/v0/set/qp/status/created", "POST", obj, (response) => {
                        try{
                        }catch(e){
                            console.log(e)
                        }
                    })
                }catch(er){
                    console.log(er)
                }
            }
        }
        $scope.request_sent = false
        $scope.shuffleOneSection = (section, index) => {
            if(qpId && section){
                let obj = {
                    qp_id : qpId,
                    section : section,
                    index : index
                }
                $scope.request_sent = true
                try{
                    authService.callAPI("/v0/qp/shuffle/selected/section", "POST", obj, (response) => {
                        try{
                            if(section.is_shuffle){
                                toastr.success("Selected shuffle option for the section")
                            }else{
                                toastr.success("Deselected shuffle option for the section")
                            }
                        }catch(e){
                            console.log(e)
                            toastr.error("Network error")
                        }
                        $scope.request_sent = false
                        $scope.$apply();
                    })
                }catch(er){
                    console.log(er)
                    $scope.request_sent = false
                    $scope.$apply();
                }
            }
        }
        
    }
}
export default FormatQuestionController



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/formatQuestion.js